import React from "react";
import PageWithHistory from "../../helpers/page-with-history";
import PurchaseDisplay from "./purchase-display";

const History = props => (
  <PageWithHistory title="Buy a Wine Blind" dataComponent={PurchaseDisplay} />
);

export default History;
